module.exports = __webpack_public_path__ + "img/chat-square-fill.d516ba63.svg";